export const CTA_MICRO_DISCLOSURE = {
  line1: "14-day free trial · No credit card",
};

export const CLOSING_CTA = {
  headlineLead: "Put Your",
  headlineGain: "Roofing Digital Employee",
  headlineMid: "on a",
  headlineAccent: "14-Day Free Trial",
  subheadline:
    "We deploy and configure your digital employee in 12 minutes. If it doesn't save at least 2 estimate inspections in its first 2 weeks, turn it off with 1 click.",
  buttonLabel: "Hire Your Roofing Digital Employee — 14 Days Free",
  disclosure: "No credit card required • 12-minute concierge onboarding • Cancel anytime",
  demoPrompt: "Need a custom enterprise setup or have questions first?",
  demoLabel: "Schedule a 10-Min Demo Call with Sales",
};
